// extracted by mini-css-extract-plugin
export default {"search_button":"referralPanel_search_button__9cAQI","header":"referralPanel_header__ANrAS","stats":"referralPanel_stats__r2k2z","container":"referralPanel_container__YjjOX"};